export default "__VITE_ASSET__Dv1SntaR__"